<template>
  <div class="go-in">
    <banner title="走进特格尔" />
    <div class="section" v-loading="loading">
      <div class="section-content">
        <div class="content-summary">
          <div class="summary-left">
            <p class="title">公司简介</p>
            <p class="eTitle">ABOUT US</p>
            <p class="content">
              {{companyInfo.companyIntroduction}}
            </p>
          </div>
          <div class="summary-right">
            <img :src="aboutusUrl" alt />
          </div>
        </div>
        <el-divider class="el-divider-active">
          <i class="el-icon-arrow-down el-icon-arrow-down-active"></i>
        </el-divider>
        <div class="content-course">
          <div class="top">
            <h3>发展历程</h3>
            <p>DEVELOPMENT</p>
            <div class="border"></div>
            <div class="timeline"></div>
          </div>
          <div class="course-time">
            <swiper :options="swiperOption" ref="mySwiper">
              <swiper-slide v-for="(item,index) in courseList" :key="index">
                <div class="time-show">
                  <div class="time-show-item" v-for="(courseOne,one) in item" :key="one">
                    <div class="item-top" :class="{'order-top' : one%2===1}"></div>
                    <el-divider>
                      <i class="el-icon-mobile-phone"></i>
                    </el-divider>
                    <div class="item-bottom" :class="{'order' : one%2===1}">
                      <div class="item-bottom-content">
                        <p>{{courseOne.description}}</p>
                        <p>{{courseOne.startTime.split('-')[0] + "年"}}{{courseOne.endTime?'至'+courseOne.endTime.split('-')[0]  + "年":''}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </swiper-slide>
              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
          </div>
        </div>
        <div class="content-culture">
          <h3>品牌文化</h3>
          <h3>CULTURE</h3>
          <div class="culture" v-html="companyInfo.companyCulture"></div>
        </div>
        <div class="content-honor">
          <div class="honor-big-img">
            <el-dialog :title="dialogTitle" :visible.sync="dialogTableVisible">
              <img v-lazy="dialogUrl" alt />
            </el-dialog>
          </div>
          <div class="top">
            <h3>公司资质</h3>
            <p>HONOR</p>
            <div class="border"></div>
          </div>
          <ul class="honor-show">
            <li v-for="(honor,index) in honorList" :key="index">
              <img v-lazy="honor" @click="dialogTableVisible = true ;dialogUrl = honor;dialogTitle= honor.remark" />
            </li>
          </ul>
          <p>点击图片查看大图</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
import {
  swiper,
  swiperSlide
} from "vue-awesome-swiper";
export default {
  components: {
    Banner,
    swiper,
    swiperSlide
  },
  data() {
    return {
      aboutusUrl: "",
      loading: false,
      honorList: [],
      partnerImg: [],
      courseList: [],
      teamItem: [],
      swiperOption: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      dialogTableVisible: false,
      dialogUrl: "",
      dialogTitle: "",
      companyInfo: {},
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.$http
          .all([
            this.$http.get("api-homepage/home/homepage/page"),
            this.$http.get("api-homepage/home/homepage/develop"),
            this.$http.get("api-homepage/home/homepage/filePath?fileName=&fileType=公司资质"),
            this.$http.get("api-homepage/home/homepage/filePath?fileName=&fileType=公司简介右图")
          ])
          .then(
              this.$http.spread(
                  (response, responseCourse, responseHonor, responseAbout) => {
                    this.companyInfo = response.data.data[0] || [];
                    let honorData = responseHonor.data || [];

                    if(honorData.data.length){
                      if(honorData.data[0].filePath.indexOf(',') > 0){
                        this.honorList = honorData.data[0].filePath.split(',')
                      }else{
                        this.honorList.push(honorData.data[0].filePath);
                      }
                    }
                    let courseData = responseCourse.data;
                    if(courseData.data.length){
                      var groupCount = Math.ceil(courseData.data.length / 2);
                      for (let i = 0; i < groupCount; i++) {
                        let item = [];
                        for (let j = 0; j < 2; j++) {
                          if (courseData.data.length - 1 >= i * 2 + j) {
                            item.push(courseData.data[i * 2 + j]);
                          }
                        }
                        this.courseList.push(item);
                      }
                    }
                    let aboutusData  = responseAbout.data.data[0] || {};
                    if(aboutusData){
                      this.aboutusUrl = aboutusData.filePath;
                    }
                    this.loading = false;
                  }
              )
          );
    },
  }
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.go-in {
  width: 100%;
  height: 100%;
  background-color: #f5f5f5;
  position: relative;
  overflow: hidden;
  .section {
    width: 100%;
    .section-content {
      width: 1240px;
      margin: 0 auto;
      background-color: #fff;
      .content-summary {
        display: flex;
        justify-content: space-around;
        padding: 100px 0;
        .summary-left {
          width: 600px;
          .title {
            font-size: 25px;
            color: #e13834;
          }
          .eTitle {
            font-size: 17px;
            color: #e13834;
            padding: 20px 0;
          }
          .content {
            color: #333333;
            font-size: 14px;
            text-indent: 25px;
            line-height: 30px;
          }
        }
        .summary-right {
          width: 400px;
          height: 310px;
          border-radius: 10px;
          margin-top: 80px;
          text-align: center;
          img {
            width: 360px;
            height: 270px;
            margin-top: 20px;
          }
        }
      }
      .content-course {
        padding: 50px 0;
        .course-time {
          width: 1000px;
          height: 400px;
          margin: 20px auto;
          .swiper-container {
            height: 100%;
          }
          .time-show {
            width: 700px;
            height: 100%;
            margin: 0 auto;
            display: flex;
            .time-show-item {
              width: 350px;
              height: 100%;
              overflow: hidden;
              display: flex;
              flex-direction: column;
              .item-top,
              .item-bottom {
                height: 190px;
              }
              .item-bottom {
                .item-bottom-content {
                  background-color: #48a83c;
                  margin: 20px 0;
                  border-radius: 10px;
                  p {
                    color: #fff;
                    text-align: center;
                    padding: 15px;
                  }
                }
              }
            }
          }
        }
      }
      .content-culture {
        height: 450px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        padding-left: 100px;
        background-color: #03c16133;
        h3 {
          color: #48a83c;
          font-size: 26px;
        }
        .culture{
          color: #333333;
          font-weight: 400;
          line-height: 36px;
          font-size: 18px;
          padding: 5px 0;
        }
      }
      .content-honor {
        padding: 50px 0;
        .honor-show {
          width: 1000px;
          margin: 30px auto;
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-start;
          align-content: flex-start;
          li {
            width: 220px;
            height: 320px;
            margin-left: 15px;
            margin-bottom: 15px;
            list-style: none;
            border: 1px solid palegoldenrod;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
        p {
          text-align: center;
          color: #333333;
        }
      }
    }
  }
}
@keyframes imgboxkey {
  0% {
    border: solid rgb(29, 66, 185) 2px;
  }
  40% {
    border: solid rgb(255, 255, 255) 2px;
  }
  60% {
    border: solid rgb(255, 255, 255) 2px;
  }
  100% {
    border: solid rgb(29, 66, 185) 2px;
  }
}
@keyframes imgbo {
  0% {
    transform: scale(1);
    box-shadow: 0px 0px 0px 0px #ababab;
  }
  50% {
    transform: scale(1.1);
    box-shadow: 0px 0px 10px 5px #ababab;
  }
  100% {
    transform: scale(1);
    box-shadow: 0px 0px 0px 0px #ababab;
  }
}
.el-divider--horizontal {
  margin: 1px 0;
}
.top {
  h3,
  p {
    text-align: center;
    color: #333333;
    font-weight: 400;
    padding: 10px 0;
  }
  h3 {
    font-size: 30px;
  }
  p {
    font-size: 20px;
  }
  .border {
    border-bottom: 1px solid #333333;
    width: 15%;
    margin: 0 auto;
  }
}
.order {
  order: -1;
}
.order-top {
  order: 1;
}
.el-divider {
  background-color: #dddddd;
  height: 3px;
  .el-divider__text {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    padding: 0px;
    color: #fff;
    border: 3px solid red;
  }
}
.honor-big-img {
  width: 100%;
  height: 100%;
  z-index: 10;
  text-align: center;
  padding-bottom: 20px;
  padding: 5%;
  .el-dialog__wrapper {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;
    .el-dialog__body {
      overflow: hidden;
      img {
        width: 100%;
      }
    }
  }
}
@media screen and (max-width: 1240px) {
  .go-in .section .section-content {
    width: 100%;
    padding: 0 15px;
  }
}
@media screen and (max-width: 992px) {
  .go-in .section .section-content .content-summary {
    flex-direction: column;
    padding: 40px 0;
    .summary-left {
      width: 100%;
      margin-bottom: 30px;
      .title {
        font-size: 22px;
      }
      .eTitle {
        font-size: 16px;
      }
      .content {
        font-size: 14px;
        line-height: 26px;
      }
    }
    .summary-right {
      width: 100%;
      height: auto;
      margin-top: 20px;
      img {
        width: 100%;
        max-width: 360px;
        height: auto;
      }
    }
  }
  .go-in .section .section-content .content-course .course-time {
    width: 100%;
    height: auto;
    padding: 0 10px;
    .time-show {
      width: 100%;
    }
    .time-show-item {
      width: 50% !important;
      .item-bottom {
        font-size: 12px !important;
      }
      .item-bottom {
        .item-bottom-content {
          margin: 20px !important;;
          p {
            padding: 10px !important;;
          }
        }
      }
    }
  }
  .go-in .section .section-content .content-culture {
    height: auto;
    padding: 40px 15px;
    h3 {
      font-size: 24px;
    }
    .culture {
      font-size: 16px;
      line-height: 30px;
    }
  }
  .go-in .section .section-content .content-honor .honor-show {
    width: 100%;
    justify-content: center;
    li {
      width: 42%;
      height: auto;
      margin: 0 5px 15px;
    }
  }
  .top h3 {
    font-size: 26px;
  }
  .top p {
    font-size: 18px;
  }

  .swiper-button-prev, .swiper-button-next {
    top: 37% !important;
  }

  .swiper-button-prev {
    left: 0 !important;
  }

  .swiper-button-next {
    right: 0 !important;
  }
  
}
@media screen and (max-width: 768px) {
  .go-in .section .section-content .content-summary {
    padding: 30px 0;
  }
  .go-in .section .section-content .content-course {
    padding: 30px 0;
    .course-time {
      height: 460px;
    }
    .time-show-item {
      width: 100% !important;
      .item-bottom {
        font-size: 12px !important;
      }
      .item-bottom {
        .item-bottom-content {
          margin: 20px !important;
          p {
            padding: 10px !important;;
          }
        }
      }
    }
  }
  .go-in .section .section-content .content-honor .honor-show li {
    width: 45%;
  }

  .swiper-button-prev, .swiper-button-next {
    top: 37% !important;
  }

  .swiper-button-prev {
    left: 0 !important;
  }

  .swiper-button-next {
    right: 0 !important;
  }

}
@media screen and (max-width: 480px) {
  .go-in .section .section-content .content-honor .honor-show li {
    width: 90%;
  }
  .top h3 {
    font-size: 22px;
  }
  .top p {
    font-size: 16px;
  }
}
</style>